import maplibregl, { type LngLatLike, type Map as MapLibreMap, type Popup } from 'maplibre-gl'

import { Z_INDEX } from '@/utils/zIndex'

type ShowMapHoverPopupOptions = {
  map: MapLibreMap
  popup: Popup | null
  lngLat: LngLatLike
  html: string
  className?: string
  offset?: number
  maxWidth?: string
}

export function showMapHoverPopup({
  map,
  popup,
  lngLat,
  html,
  className,
  offset = 12,
  maxWidth = 'none',
}: ShowMapHoverPopupOptions): Popup {
  if (popup) {
    popup.setLngLat(lngLat).setHTML(html)
    return popup
  }

  const nextPopup = new maplibregl.Popup({
    closeButton: false,
    closeOnClick: false,
    className,
    offset,
    maxWidth,
  })
    .setLngLat(lngLat)
    .setHTML(html)
    .addTo(map)

  const popupEl = nextPopup.getElement()
  const contentEl = popupEl?.querySelector<HTMLElement>('.maplibregl-popup-content')
  const tipEl = popupEl?.querySelector<HTMLElement>('.maplibregl-popup-tip')
  if (contentEl) {
    contentEl.style.padding = '8px 10px'
    contentEl.style.borderRadius = '6px'
    contentEl.style.boxShadow = '0 2px 8px rgba(0,0,0,0.15), 0 1px 3px rgba(0,0,0,0.1)'
    contentEl.style.pointerEvents = 'none'
  }
  if (tipEl) tipEl.style.display = 'none'

  popupEl.style.zIndex = Z_INDEX.POPOVER.toString()
  return nextPopup
}

export function hideMapHoverPopup(popup: Popup | null): null {
  popup?.remove()
  return null
}
